import { createSlice } from "@reduxjs/toolkit";

export const privateChat = createSlice({
  name: "private_chat",
  initialState: {
    value: {
      status: false,
      dmFromCommunity: { isSet: false, username: "" },
      chatIds: { isRegistered: false, chatIds: [] },
      chatData: [],
      chatSelected: { chatId: "" },
      selectedChatMessages: [],
      // appBarNotifications: {
      //   number: 0,
      //   messages: [],
      // },
    },
  },
  reducers: {
    updateChatIds: (state, action) => {
      state.value.chatIds = {
        isRegistered: true,
        chatIds: action.payload.chatids,
      };
    },
    appendNewChatId: (state, action) => {
      state.value.chatIds.chatIds = [
        ...state.value.chatIds.chatIds,
        action.payload.chatid,
      ];
    },
    updateAllChatData: (state, action) => {
      state.value.status = true;
      state.value.chatData = action.payload;
    },
    updateChatList: (state, action) => {
      const updateArray = [action.payload, ...state.value.chatData];
      state.value.chatData = updateArray;
    },
    clearNotifications: (state, action) => {
      const updatedChats = [];
      state.value.chatData.forEach((item, index) => {
        if (item.chatId === action.payload.chatId) {
          updatedChats.push({
            messages: item.messages,
            participants: item.participants,
            chatId: item.chatId,
            who_i_am_chatting: item.who_i_am_chatting,
            who_is_chatting: item.who_is_chatting,
          });
        } else {
          updatedChats.push(item);
        }
      });
      state.value.chatData = updatedChats;
    },
    updateChatMessages: (state, action) => {
      const updateSentMessages = [];
      state.value.chatData.forEach((item, index) => {
        if (item.chatId === action.payload.chatId) {
          updateSentMessages.push({
            messages: {
              sender: {
                _id: action.payload.userId,
                country: "",
                userType: "",
                gender: "",
                displayPicture: {
                  Key: "",
                  URL: "",
                },
                username: action.payload.username,
              },
              receiver: {
                _id: action.payload.who_i_am_chatting_userId,
                country: "",
                userType: "",
                gender: "",
                displayPicture: {
                  Key: "",
                  URL: "",
                },
                username: action.payload.who_i_am_chatting_username,
              },
              messageType: "text",
              content: action.payload.message,
              timestamp: new Date(),
              createdAt: "",
              updatedAt: "",
            },
            participants: item.participants,
            chatId: item.chatId,
            who_i_am_chatting: item.who_i_am_chatting,
            who_is_chatting: item.who_is_chatting,
          });
        } else {
          updateSentMessages.push(item);
        }
      });
      state.value.chatData = updateSentMessages;
    },
    incomingMessages: (state, action) => {
      const data = action.payload.data;
      const updateIncomingMessageList = [];

      //check if chat already exist
      const filtered = state.value.chatData.filter((item, index) => {
        return item.chatId === action.payload.chatId;
      });
      //if it exists, add the last message
      if (filtered.length > 0) {
        state.value.chatData.forEach((item, index) => {
          if (item.chatId === action.payload.chatId) {
            updateIncomingMessageList.push({
              messages: {
                sender: {
                  _id: data.sender,
                  country: "",
                  userType: "",
                  gender: "",
                  displayPicture: {
                    Key: "",
                    URL: "",
                  },
                  username: "",
                },
                receiver: {
                  _id: data.receiver,
                  country: "",
                  userType: "",
                  gender: "",
                  displayPicture: {
                    Key: "",
                    URL: "",
                  },
                  username: "",
                },
                messageType: data.messageType,
                content: data.content,
                timestamp: data.timestamp,
                createdAt: "",
                updatedAt: "",
              },
              participants: item.participants,
              chatId: item.chatId,
              who_i_am_chatting: item.who_i_am_chatting,
              who_is_chatting: item.who_is_chatting,
              chatNotifications: item.chatNotifications
                ? item.chatNotifications + 1
                : 0 + 1,
            });
          } else {
            updateIncomingMessageList.push(item);
          }
        });
        state.value.chatData = updateIncomingMessageList;
      } else {
        //if it does not exist, create a new chat entry

        const updateArray = [
          action.payload.newChatEntry,
          ...state.value.chatData,
        ];
        state.value.chatData = updateArray;
      }
    },
    updateChatSelected: (state, action) => {
      state.value.chatSelected = action.payload;
    },
    updateSelectedChatMessages: (state, action) => {
      state.value.selectedChatMessages = action.payload;
    },
    selectedChatNewMessage: (state, action) => {
      state.value.selectedChatMessages = [
        ...state.value.selectedChatMessages,
        action.payload.message,
      ];
    },
    removeMessage: (state, action) => {
      state.value.selectedChatMessages.splice(action.payload.index, 1);
    },
    updateDmFromCommunity: (state, action) => {
      state.value.dmFromCommunity = {
        isSet: true,
        username: action.payload.username,
      };
    },
    clearDmFromCommunity: (state) => {
      state.value.dmFromCommunity = { isSet: false, username: "" };
    },
    // appBarNotifier: (state, action) => {
    //   state.value.appBarNotifications.number =
    //     state.value.appBarNotifications.number + 1;
    //   state.value.appBarNotifications.messages = [
    //     ...state.value.appBarNotifications.messages,
    //     action.payload.messageBody,
    //   ].reverse();
    // },
    // clearAppBarMessageNotifier: (state, action) => {
    //   state.value.appBarNotifications.number = 0;
    // },
    resetPrivateChat: (state, action) => {
      state.value = {
        status: false,
        dmFromCommunity: { isSet: false, username: "" },
        chatIds: { isRegistered: false, chatIds: [] },
        chatData: [],
        chatSelected: {},
        selectedChatMessages: [],
      };
    },
  },
});

export const {
  updateChatIds,
  appendNewChatId,
  updateAllChatData,
  updateChatList,
  clearNotifications,
  updateChatMessages,
  incomingMessages,
  updateChatSelected,
  updateSelectedChatMessages,
  selectedChatNewMessage,
  removeMessage,
  updateDmFromCommunity,
  clearDmFromCommunity,
  // appBarNotifier,
  // clearAppBarMessageNotifier,
  resetPrivateChat,
} = privateChat.actions;

export default privateChat.reducer;
